<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-29 11:16:06
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-29 11:42:46
 * @FilePath: \合联\oms\src\view\order\orderTrack\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-29 11:16:06
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-29 11:16:42
 * @FilePath: \合联\oms\src\view\order\orderTrack\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/order/orderTrack.js'
export default {
  name: "",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        export: {
          type: 'add',
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData()
              this.$page.handleRequestMethods('statusExport', data, true, true).then(res => {
                this.$page.getList();
                close();
              })
            }
          },
          config: {
            title: this.$tz('创建,导出,任务'),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: '20px'
              }
            },
            rules: {
              awbno: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                },
              ],
              status: [
                {
                  required: true,
                  type: 'array',
                  message: 'cannot be empty',
                  trigger: 'blur',
                },
              ],
            }
          },
          grid: [
            { title: 24 },
            { awbno: 24 },
            { status: 24 },
            { remark: 24 },
          ],
          fields: [
            {
              name: () => this.$tz('标题'),
              key: 'title',
              component: 'Input',
              placeholder: () => this.$tz('标题'),
            },
            {
              key: 'awbno',
              name: () => this.$tz('订单号码'),
              placeholder() {
                return this.$tz('订单号码');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 3 },
              },
            },
            {
              name: this.$tz('轨迹'),
              key: 'status',
              component: 'Select',
              placeholder: () => this.$tz('轨迹'),
              options: [],
              optionsFn: 'getTrackerStatus',
              optionsKey: '',
              default: '',
              bind: {
                multiple: true
              }
            },
            {
              key: 'remark',
              name: () => this.$tz('备注'),
              placeholder() {
                return this.$tz('备注');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 3 },
              },
            },
          ]
        },
      },
      header: {
        searchs: [
          {
            key: 'startTime',
            placeholder() {
              return this.$tz('请选择,开始,日期');
            },
            component: 'DatePicker',
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: '150px',
              },
            },
          },
          {
            key: 'endTime',
            placeholder() {
              return this.$tz('请选择,结束,日期');
            },
            component: 'DatePicker',
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: '150px',
              },
            },
          },
          {
            key: 'status',
            placeholder() {
              return this.$tz('状态')
            },
            component: 'Select',
            options: [],
            optionsFn: '',
            optionsKey: 'COST_EXPORT_STATUS',
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('创建,导出,任务'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
            },
          ],
          methods: {
            export() {
              this.getModal('export').open();
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          width: 50,
          align: 'center'
        },
        {
          name: () => this.$t("zhTitle"),
          key: "title",
          minWidth: 130,
        },
        {
          name: () => this.$t("tip"),
          key: "status_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("ElapsedTime"),
          key: "take_up_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("error_mes"),
          key: "msg",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("expTime"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          key: "src",
          minWidth: 100,
          render(h, p) {
            return h('Button', {
              attrs: {
                type: 'primary',
                size: 'small',
              },
              on: {
                click: () => {
                  window.open(this.$globalUrl + p.row.src)
                }
              }
            }, this.$t('download'))
          }
        },
      ]
    }
  }
}
</script>

<style scoped></style>